import { CardsFlowData, CardsFlowStep } from "core/api";
import { StepDataResolver } from "../models";

/**
 * Cards data resolver
 *
 * Formats Cards data on form field values
 */
export const cardsDataResolver: StepDataResolver<
  CardsFlowStep,
  CardsFlowData
> = ({ data, fieldValues }) => {
  const selectedIndices =
    fieldValues.selectedCards ?? data.intSelectedIndices ?? [];

  return {
    intSelectedIndices: selectedIndices,
    selectedNames: selectedIndices.map(
      (index: number) => data.cardOptions?.[index]?.name ?? ""
    ),
  };
};
